module.exports = __webpack_public_path__ + "static/media/MKR-103-badge.e714a6e1.svg";